import React, { Component } from "react";
import Aux from "../../../hoc/Auxi/Auxi";
import classes from "./Modal.css";
import Backdrop from "../Backdrop/Backdrop";

/**
 * @desc Modal pop-up
 * @version 1.0.1
 * @author Jamshith
 * 
 */

class Modal extends Component {
  /**
   * @desc decides whether modal pop-up should be shown or not
   * @param nextProps, nextState
   * @return true or false
   */
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.show !== this.props.show ||
      nextProps.children !== this.props.children
    );
  }
  /**
   * @desc Actual rendering of the model
   * @param null
   * @return modal
   */
 

  render() {

    let viewBackdrop = true;
    if(this.props.nobackDrop){
      viewBackdrop= false;
    }
    
    return (
      <Aux>
        {viewBackdrop?<Backdrop className={this.props.backdropClassName} show={this.props.show} clicked={this.props.modalClosed} />
        :<Backdrop className={this.props.backdropClassName} show={viewBackdrop} clicked={this.props.modalClosed} />}
        
        <div
          className={"Error-modal " + this.props.className}
          style={{
            transform: this.props.show ? "translateY(0)" : "translateY(-150vh)",
            opacity: this.props.show ? "1" : "0",
            color: "red"
          }}
        >
          <div className="modal-container">{this.props.children}</div>
        </div>
      </Aux>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js